import React from 'react';
import { Button } from 'app/blocks/buttons/buttons';
import { ID, withCodes } from 'app/blocks/common/codes';
import { BasicView } from 'app/blocks/views/WidgetView';

function CoverChargeWidget({ l }: { l: l }): React.ReactElement {
    const button = (
        <Button data-seleniumid="COVER_SALES" href={l('WIDGETS.COVER_SALES.URL')} isLinkTag target="_blank">
            {l('WIDGETS.COVER_SALES.BUTTON')}
        </Button>
    );

    return (
        <BasicView actions={button} icon="cover" seleniumid="coverSales" title={l('WIDGETS.COVER_SALES.TITLE')}>
            <div dangerouslySetInnerHTML={{ __html: l('WIDGETS.COVER_SALES.CONTENT') }} />
        </BasicView>
    );
}

export default withCodes(CoverChargeWidget, ID.WIDGETS);
